var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.158 11.035h21.877a.965.965 0 010 1.93H1.158a.965.965 0 110-1.93z",
    fill: "#4E8278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.283 11.318L9.74 1.859a.965.965 0 011.365 1.365L2.33 12l8.776 8.776a.965.965 0 11-1.365 1.365L.283 12.683a.965.965 0 010-1.365z",
    fill: "#4E8278"
  })));
}
export default SvgArrowLeft;